var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgReduceptLogoNoTextWhite(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 383.93 403.06",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M250.27,227.45c62.19-87.55-3-163.64-72.87-161.7-71.92,2-148.72,86.22-96.11,290.42C93.09,402,36.77,411,24,373.13-101.06-59.56,301.31-74.18,341.56,117.82c11.76,56.12-4.41,116.12-44.9,156.58C266.5,304.53,223.34,262.06,250.27,227.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M207.34,183.81C146.86,268,218,384.06,337.69,325.42c37.2-18.22,61.82,22.44,34.82,43C303.72,420.65,212.15,411,163.7,358.23c-51-55.55-56-157.29-12.82-217.59C182.79,96.15,239,145.06,207.34,183.81Z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReduceptLogoNoTextWhite);
export default __webpack_public_path__ + "static/media/reducept-logo-no-text-white.09055a0d.svg";
export { ForwardRef as ReactComponent };